// extracted by mini-css-extract-plugin
module.exports = {"globalNavigationItems":"GlobalNavigationItems_globalNavigationItems__oYOd3"};